import { render } from "./WinView.vue?vue&type=template&id=6d1b2f40"
import script from "./WinView.vue?vue&type=script&lang=js"
export * from "./WinView.vue?vue&type=script&lang=js"

import exportComponent from "/home/flow/draceo/clients/interne/projets/glitch-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__